import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const MobileStickyBar = ({ calendlyLink }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 350);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-md border-t border-border/30 shadow-[0_-1px_8px_rgba(0,0,0,0.06)] px-4 py-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom,0px))]"
      data-testid="mobile-sticky-cta-bar"
    >
      <div className="flex gap-2 items-center">
        <Button
          asChild
          className="flex-1 bg-[#004C54] hover:bg-[#003a40] text-white font-bold h-12 text-[15px] rounded-[10px] active:scale-[0.98] shadow-md"
        >
          <a href={calendlyLink} data-testid="sticky-book-call-cta">
            Book a Discovery Call
            <ArrowRight className="ml-1.5 h-4 w-4" />
          </a>
        </Button>
        <Button
          asChild
          variant="ghost"
          className="shrink-0 text-[#004C54] hover:bg-[#004C54]/10 font-semibold h-12 px-3 rounded-[10px]"
        >
          <a href="/quiz" data-testid="sticky-quiz-cta" aria-label="Take the 2-minute Mindset Quiz">
            <Sparkles className="h-4 w-4 mr-1" />
            <span className="text-[13px]">Quiz</span>
          </a>
        </Button>
      </div>
    </div>
  );
};

export default MobileStickyBar;
